import { createTRPCReact } from '@trpc/react-query';

import type { AppRouter } from '@calorie-tracker/api';

export const trpc = createTRPCReact<AppRouter>();
